module.exports = __webpack_public_path__ + "img/features-and-benefits.977b589.png";